export const BRANDED_WORKSPACE_REDIRECT_QUERY_PARAM_KEY = 'redirectBrandedSubdomainData';
export const MAX_SUBDOMAIN_LENGTH = 63;
